module.exports = __webpack_public_path__ + "static/media/L-0.75836050.svg";